// Packages
import { useNavigate } from "react-router-dom";

// Steps controllers
import useRolesView from './Views';
import useRolesCreate from './Create';
import useRolesEdit from './Edit';

const useRoles = () => {
  // State
  const navigation = useNavigate();

  const handleBack = () => {
    navigation(-1);
  };

  const header = {
    '/roles': ["Roles"],
    '/roles/creacion': ["Roles", "Crear Rol"],
    '/roles/editar': ["Roles", "Edición de rol"],
  };

  return {
    handleBack,
    header,
    useRolesEdit,
    useRolesCreate,
    useRolesView,
  };
};

export default useRoles;
